/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneArticlePaywall as ResolvedStandaloneArticlePaywall } from 'base/components/standalone/ArticlePaywall';

export const ArticlePaywall: typeof ResolvedStandaloneArticlePaywall = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneArticlePaywall {...props} />
        </ErrorBoundary>
    );
});

export type ArticlePaywallProps = PropsFromComponent<typeof ArticlePaywall>;

/** @deprecated Use slot architecture instead */
export const ArticlePaywallWith = (extras: DynamicStandaloneExtras): typeof ArticlePaywall => {
    return function ArticlePaywall(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticlePaywall');
        return <ResolvedStandaloneArticlePaywall {...mergeProps({ options: { theme } }, props)} />;
    }
}